import { IconButton, Stack, Typography, useTheme } from '@mui/material';
import { LightTooltip } from 'src/components';
import { ImportantText } from '../style';
import { InfoIconV2 } from 'src/assets/icons/InfoIconV2';

export const AdvancedTagMappingTooltip = () => {
  const theme = useTheme();

  return (
    <LightTooltip
      placement="bottom"
      arrow
      enterTouchDelay={0}
      title={
        <Typography
          variant="body1"
          sx={{
            fontWeight: 400,
            fontSize: '14px',
            whiteSpace: 'pre-wrap',
            wordWrap: 'break-word',
            color: theme.palette.text.secondary,
          }}
        >
          <ImportantText
            style={{ fontWeight: 'bold', color: theme.palette.text.primary }}
            theme={theme}
          >
            Advanced Tag Mapping
          </ImportantText>{' '}
          is not available. To enable it <ImportantText theme={theme}>Tag Type</ImportantText> needs
          to be set.
        </Typography>
      }
    >
      <Stack justifyContent="center">
        <IconButton style={{ pointerEvents: 'none' }}>
          <InfoIconV2 width={20} height={20} />
        </IconButton>
      </Stack>
    </LightTooltip>
  );
};
